import { DayPicker } from "react-day-picker";
import { AssortGroup } from "../../../models/AssortGroup";
import "../../../../style/calendar.scss";
import "../../../../style/block.scss";
import "./style.scss";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import { addDays, format } from "date-fns";
import EADivider from "../../shared/EADivider";
import { useEffect, useState } from "react";

interface IProps {
  item: AssortGroup;
  selectedDate: Date;
  setDateBetween: (date: Date) => void;
  ids: string;
}

const CalendarPassDesktop: React.FC<IProps> = ({ item, selectedDate, setDateBetween, ids }) => {
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();
  const isDiscount = item.price !== item.listPrice;
  const [dateRange, setDateRange] = useState<{ toDate: Date } | null>(null);

  useEffect(() => {
    const today = new Date();
    const futureDate = new Date();
    if (ids === "1243" || ids === "1241") {
      futureDate.setDate(today.getDate() + 31);
      setDateRange({ toDate: futureDate });
    } else {
      futureDate.setDate(today.getDate() + 90);
      setDateRange({ toDate: futureDate });
    }
    //eslint-disable-next-line
  }, []);

  return (
    <div className="calendar-pass">
      <div className="calendar-pass-calendar">
        <DayPicker
          mode="single"
          locale={locale}
          selected={selectedDate}
          fromDate={new Date()}
          toDate={dateRange?.toDate}
          onSelect={(date) => {
            setDateBetween(date ?? new Date());
          }}
          showOutsideDays
          modifiersClassNames={{
            selected: "my-selected",
            today: "my-today",
          }}
        />
      </div>

      <EADivider />

      <div className="calendar-pass-details">
        <div className="flex-between-center">
          <span className="text-color-dark">{t("waznosc")}:</span>
          <b className="text-color-dark">
            {format(selectedDate, "dd.MM.yyyy")} - {format(addDays(selectedDate, item.dayValidate), "dd.MM.yyyy")}
          </b>
        </div>
        <div className="flex-between-center">
          <span className="text-color-dark">{t("wartosc_karnetu")}:</span>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 4 }}>
            <b className={`price text-color-dark ${isDiscount ? "price-through" : ""}`}>
              {item.listPrice.toFixed(2)} {t("zl")}
            </b>
            {isDiscount && (
              <b className={`price ${isDiscount ? "price-through-color" : ""}`}>
                {item.price.toFixed(2)} {t("zl")}
              </b>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarPassDesktop;
